export default __webpack_public_path__ + "static/media/ps3.027132d8.jpeg";